import { render, staticRenderFns } from "./formular_anmeldung.vue?vue&type=template&id=ab0a3972&"
import script from "./formular_anmeldung.vue?vue&type=script&lang=js&"
export * from "./formular_anmeldung.vue?vue&type=script&lang=js&"
import style0 from "./formular_anmeldung.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports